
import { commonModule, companyModule } from "@/store/modules/store-accessor";
import { sortDateRange } from "@/helpers/data";
import { resolveInitialDateRange } from "@/helpers/filterPersistence";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import FilterList from "./FilterList.vue";
import DatePickerFilter from "./DatePickerFilter.vue";
import dayjs from "dayjs";

// Read the persisted preset/custom range for this page and fall back to
// "today" when nothing has been persisted yet.
function initialOfferDates(): [string, string] {
  const resolved = resolveInitialDateRange("offers");
  if (resolved) return [resolved.from, resolved.to];
  return [
    dayjs().startOf("day").toISOString(),
    dayjs().endOf("day").toISOString(),
  ];
}

@Component({
  components: {
    FilterList,
    DatePickerFilter,
  },
})
export default class OfferFilter extends Vue {
  selectedStatuses: any[] = [];
  selectedAssignees: any[] = [];
  selectedDates: any = initialOfferDates();
  selectedClients: any[] = [];

  mounted() {
    if (this.selectedDates && this.selectedDates.length === 2) {
      this.submit();
    }
  }

  get statusOptions() {
    return ["DRAFT", "SENT", "ACCEPTED", "REJECTED", "EXPIRED"].map((status) => ({
      text: this.$t(status),
      value: status,
    }));
  }

  get assigneeDropdownLabel() {
    if (companyModule.company?.modules?.includes("DFB_PORTAL_PARTNERS")) {
      return "userPartner";
    }

    return "user";
  }

  get assigneeOptions() {
    const assignees = companyModule.company?.modules?.includes("DFB_PORTAL_PARTNERS") ? commonModule.personnelPartnersCombo : commonModule.personnelCombo;

    return assignees?.map((obj: any) => ({
      ...obj,
      icon: obj?.is_partner ? "mdi-account-multiple" : "mdi-account",
    }));
  }

  get clientOptions() {
    return commonModule.clientsCombo?.map((obj: any) => ({
      ...obj,
      icon: obj.is_business ? "mdi-domain" : "mdi-account",
      name: obj.is_business ? `${obj.entity_name} (${obj.name})` : obj.name,
    }));
  }

  updateStatuses(data: any[]) {
    this.selectedStatuses = data || [];
    this.submit();
  }

  updateAssignees(data: any[]) {
    this.selectedAssignees = data || [];
    this.submit();
  }

  updateDates(data: any[]) {
    this.selectedDates = data;
    if (!this.selectedDates || this.selectedDates.length === 2) {
      this.submit();
    }
  }

  updateClients(data: any[]) {
    this.selectedClients = data || [];
    this.submit();
  }

  submit() {
    const queryObj: any = {};

    const statuses = this.selectedStatuses.map((status) => status.value);
    if (statuses.length > 0) {
      queryObj.status = statuses;
    }

    const assigneeIds = this.selectedAssignees.map((assignee) => assignee.id);
    if (assigneeIds.length > 0) {
      queryObj.assignee_id = assigneeIds;
    }

    if (this.selectedDates && this.selectedDates.length === 2) {
      sortDateRange(this.selectedDates);
      queryObj.date_from = dayjs(this.selectedDates[0]).startOf("day").toISOString();
      queryObj.date_to = dayjs(this.selectedDates[1]).endOf("day").toISOString();
    }

    const clientIds = this.selectedClients.map((client) => client.id);
    if (clientIds.length > 0) {
      queryObj.clients = clientIds;
    }

    this.$emit("update-filters", queryObj);
  }
}
